// "Afegeix despesa" form — shared by the unitat drawer (money view) and
// the classic detail panel (caps/unitat views). State lives in the
// Factures context so both hosts see the same fields.

import { CapNameInput } from './CapNameInput';
import { useFactures } from './useFacturesContext';
import { Button, FormGroup, Input, Label } from '../Shared/FormStyles';
import { FormRow, NoteText, Panel } from './Factures.styles';

export const DespesaForm = () => {
	const fac = useFactures();
	return (
		<Panel>
			<FormRow>
				<FormGroup>
					<Label>Concepte *</Label>
					<Input
						value={fac.fConcept}
						placeholder="p. ex. material excursió"
						onChange={(e) => fac.setFConcept(e.target.value)}
					/>
				</FormGroup>
			</FormRow>
			<FormRow>
				<FormGroup>
					<Label>Import total *</Label>
					<Input
						value={fac.fAmount}
						placeholder="24,50"
						inputMode="decimal"
						onChange={(e) => fac.setFAmount(e.target.value)}
					/>
				</FormGroup>
				{/* any despesa creator may declare the split: the cap
				knows at payment time what was unitat vs agrupament. */}
				<FormGroup>
					<Label>Part que carrega a la unitat (opcional)</Label>
					<Input
						value={fac.fUnitatCharge}
						placeholder="deixa buit = tot"
						inputMode="decimal"
						onChange={(e) => fac.setFUnitatCharge(e.target.value)}
					/>
					<NoteText>
						La resta va a l'agrupament
					</NoteText>
				</FormGroup>
			</FormRow>
			<FormRow>
				<FormGroup>
					<Label>El teu nom (Nom Cognom) *</Label>
					<CapNameInput
						value={fac.fCapName}
						onChange={fac.setFCapName}
						suggestions={fac.capNames}
						required
					/>
				</FormGroup>
				<FormGroup>
					<Label>Data de la despesa (opcional)</Label>
					<Input
						type="date"
						value={fac.fDate}
						onChange={(e) => fac.setFDate(e.target.value)}
					/>
				</FormGroup>
			</FormRow>
			<FormRow>
				<FormGroup>
					<Label>
						Factura o tiquet (opcional; foto o PDF, màx 10MB)
					</Label>
					<Input
						type="file"
						accept="image/jpeg,image/png,image/webp,image/heic,application/pdf"
						onChange={(e) =>
							fac.setFReceipt((e.target.files as FileList)[0] ?? null)
						}
					/>
				</FormGroup>
			</FormRow>
			<Button
				onClick={fac.addDespesa}
				disabled={
					fac.submitting || !fac.fConcept.trim() || !fac.fCapName.trim()
				}
			>
				{fac.submitting ? 'Enviant…' : 'Afegeix'}
			</Button>
		</Panel>
	);
};
